import angular from 'angular';
import { loanTableComponent } from './loan-table.component';

const MODULE_NAME = 'loanTable';

export default angular.module(MODULE_NAME, []).component('loanTableComponent', loanTableComponent).name;
